import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FormControlLabel, Stack, Typography } from '@emburse/embark-core';
import { $t } from '../../../hooks/useTranslation';
export default function CorpAuditConfigDrawerExpenseTypes({ auditDefinitionPayload, globalExpenseTypes, setAuditDefinitionPayload }) {
    const handleCheckboxChange = (typeID, checked) => {
        setAuditDefinitionPayload((prevValues) => {
            const updatedExpenseTypes = !checked
                ? [...prevValues.ExpenseTypes, typeID]
                : prevValues.ExpenseTypes.filter((id) => id !== typeID);
            return { ...prevValues, ExpenseTypes: updatedExpenseTypes };
        });
    };
    return (_jsxs(Stack, { alignItems: "flex-start", children: [_jsx(Typography, { variant: "subtitle1", children: $t('Expense Types') }), globalExpenseTypes.map((expenseType) => (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: !auditDefinitionPayload.ExpenseTypes.includes(expenseType.Value), onChange: (e) => handleCheckboxChange(expenseType.Value, e.target.checked), "data-qa": "expense-type-checkbox" }), label: $t(expenseType.Name) }, expenseType.Value)))] }));
}
